import { GET, POST, PATCH, DELETE, POST_FORM } from "../config";

export const list = async (page, filters = {}) => {
  // Construir URL de forma más limpia
  const params = new URLSearchParams();
  params.append("page", page);

  if (filters.name) params.append("name__icontains", filters.name);
  if (filters.branch) params.append("branch", filters.branch);
  if (filters.dni) params.append("dni__icontains", filters.dni);
  if (filters.address) params.append("address__icontains", filters.address);
  if (filters.client_code)
    params.append("client_code__icontains", filters.client_code);

  const response = await GET(`customers/clients/?${params.toString()}`);
  return response.data;
};

export const list_all = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.name) params.append("name__icontains", filters.name);
  if (filters.branch) params.append("branch", filters.branch);
  if (filters.dni) params.append("dni__icontains", filters.dni);
  if (filters.address) params.append("address__icontains", filters.address);
  if (filters.client_code)
    params.append("client_code__icontains", filters.client_code);

  // NOTA: El backend tiene endpoint /total/ según auditoría, pero verificando...
  // Usar page_size grande como fallback
  params.append("page_size", "1000");

  const response = await GET(`customers/clients/total/?${params.toString()}`);
  return response.data;
};

export const create = async (values) => {
  const response = await POST("customers/clients/", values);
  return response;
};
export const get = async (id) => {
  const response = await GET(`customers/clients/${id}/`);
  return response.data;
};

export const update = async (id, data) => {
  const response = await PATCH(`customers/clients/${id}/`, data);
  return response;
};
export const destroy = async (id) => {
  const response = await DELETE(`customers/clients/${id}/`);
  return response;
};

export const get_stats = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.name) params.append("name", filters.name);
  if (filters.branch) params.append("branch", filters.branch);
  if (filters.dni) params.append("dni", filters.dni);
  if (filters.address) params.append("address", filters.address);
  if (filters.client_code) params.append("client_code", filters.client_code);

  const response = await GET(`customers/clients/stats/?${params.toString()}`);
  return response.data;
};

export const bulkImport = async (file, branch = null) => {
  let url = "customers/clients/bulk_import/";
  if (branch) {
    url += `?branch=${branch}`;
  }

  const response = await POST_FORM(url, {
    file,
  });
  return response.data;
};

/**
 * Búsqueda de clientes con paginación para selects.
 * Ideal para componentes con muchos clientes.
 *
 * @param {Object} params - Parámetros de búsqueda
 * @param {string} params.search - Texto de búsqueda (nombre, dni, email, teléfono, código)
 * @param {number} params.branch - ID de sucursal
 * @param {number} params.page - Número de página (default: 1)
 * @param {number} params.page_size - Resultados por página (default: 20)
 * @returns {Promise<{results: Array, count: number, page: number, total_pages: number, has_next: boolean, has_previous: boolean}>}
 */
export const search = async ({ search = "", branch = null, page = 1, page_size = 20 } = {}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);
  if (branch) params.append("branch", branch);
  params.append("page", page);
  params.append("page_size", page_size);

  const response = await GET(`customers/clients/search/?${params.toString()}`);
  return response.data;
};

/**
 * Obtener clientes con ingresos pendientes (para crear convenios de pago APR)
 *
 * @param {Object} params - Parámetros de búsqueda
 * @param {string} params.search - Texto de búsqueda (nombre, dni, email, teléfono)
 * @param {number} params.branch - ID de sucursal (opcional, usa sucursal actual por defecto)
 * @returns {Promise<{results: Array, count: number, total_pending_amount: number}>}
 */
export const getClientsWithPendingRevenues = async ({ search = "", branch = null } = {}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);
  if (branch) params.append("branch", branch);

  const response = await GET(`customers/clients/with-pending-revenues/?${params.toString()}`);
  return response.data;
};

// [SUCCESS] CONTACTOS CORREGIDOS - Endpoints correctos
const create_contact = async (data) => {
  const response = await POST("customers/contacts/", data);
  return response;
};

const list_contacts = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.client) params.append("client", filters.client);
  if (filters.branch) params.append("branch", filters.branch);
  if (filters.contact_type) params.append("contact_type", filters.contact_type);

  const response = await GET(`customers/contacts/?${params.toString()}`);
  return response.data;
};

const update_contact = async (id, data) => {
  const response = await PATCH(`customers/contacts/${id}/`, data);
  return response;
};

const destroy_contact = async (id) => {
  const response = await DELETE(`customers/contacts/${id}/`);
  return response;
};

// [SUCCESS] CARGOS DINÁMICOS - Nuevos endpoints
const create_job_title = async (data) => {
  const response = await POST("customers/job-titles/", data);
  return response;
};

const list_job_titles = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.branch) params.append("created_by_branch", filters.branch);
  if (filters.level) params.append("level", filters.level);
  if (filters.is_active !== undefined)
    params.append("is_active", filters.is_active);
  // Filtrar por tipo (clientes o proveedores)
  if (filters.is_for_suppliers !== undefined)
    params.append("is_for_suppliers", filters.is_for_suppliers);

  console.log("[DEBUG] API: list_job_titles filters:", filters);
  console.log("[DEBUG] API: list_job_titles params:", params.toString());

  const response = await GET(`customers/job-titles/?${params.toString()}`);
  console.log("[DEBUG] API: list_job_titles response:", response.data);
  return response.data;
};

const update_job_title = async (id, data) => {
  const response = await PATCH(`customers/job-titles/${id}/`, data);
  return response;
};

const destroy_job_title = async (id) => {
  const response = await DELETE(`customers/job-titles/${id}/`);
  return response;
};

// [SUCCESS] DEPARTAMENTOS DINÁMICOS - Nuevos endpoints
const create_department = async (data) => {
  const response = await POST("customers/departments/", data);
  return response;
};

const list_departments = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.branch) params.append("created_by_branch", filters.branch);
  if (filters.department_type)
    params.append("department_type", filters.department_type);
  if (filters.is_active !== undefined)
    params.append("is_active", filters.is_active);

  console.log("[DEBUG] API: list_departments filters:", filters);
  console.log("[DEBUG] API: list_departments params:", params.toString());

  const response = await GET(`customers/departments/?${params.toString()}`);
  console.log("[DEBUG] API: list_departments response:", response.data);
  return response.data;
};

const update_department = async (id, data) => {
  const response = await PATCH(`customers/departments/${id}/`, data);
  return response;
};

const destroy_department = async (id) => {
  const response = await DELETE(`customers/departments/${id}/`);
  return response;
};

export const contacts = {
  create: create_contact,
  list: list_contacts,
  update: update_contact,
  destroy: destroy_contact,
  total: list_all,
};

// [SUCCESS] Exportar nuevos endpoints
export const jobTitles = {
  create: create_job_title,
  list: list_job_titles,
  update: update_job_title,
  destroy: destroy_job_title,
};

export const departments = {
  create: create_department,
  list: list_departments,
  update: update_department,
  destroy: destroy_department,
};
